// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3uXt3","tab":"Tabs_tab__xyEsD","tabActive":"Tabs_tabActive__2Bm_n"};